import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Heart, Handshake, Eye, Target, Quote } from 'lucide-react';
import { whyTekClap, images } from '../data/mock';

const differentiatorIcons = [
  Heart,
  Handshake,
  Eye,
  Target,
];

const WhyTekClapPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src={images.heroAlt}
            alt="Innovation"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/90 to-white/80" />
        </div>
        <div className="container-custom relative z-10">
          <div className="max-w-3xl">
            <span className="text-[#F58B23] font-medium text-sm uppercase tracking-wider mb-4 block">
              Our Difference
            </span>
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1A1A1A] mb-6">
              Why TekClap?
            </h1>
            <p className="text-lg text-[#6B7280] leading-relaxed">
              In a world of countless consulting options, here's what makes 
              partnering with TekClap different.
            </p>
          </div>
        </div>
      </section>

      {/* Differentiators Section */}
      <section className="py-20 bg-white">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-8">
            {whyTekClap.differentiators.map((diff, index) => {
              const IconComponent = differentiatorIcons[index] || Heart;
              return (
                <div
                  key={index}
                  className="bg-[#FAFAF8] rounded-2xl p-8 border border-gray-100 card-hover"
                >
                  <div className="icon-container mb-6">
                    <IconComponent className="w-6 h-6 text-[#F58B23]" />
                  </div>
                  <h3 className="text-xl font-serif font-semibold text-[#1A1A1A] mb-4">
                    {diff.title}
                  </h3>
                  <p className="text-[#6B7280] leading-relaxed">
                    {diff.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Feature Image */}
      <section className="py-12 bg-[#FAFAF8]">
        <div className="container-custom">
          <div className="rounded-2xl overflow-hidden">
            <img
              src={images.partnership}
              alt="Partnership Excellence"
              className="w-full h-64 md:h-80 object-cover"
            />
          </div>
        </div>
      </section>

      {/* Promise Section */}
      <section className="py-20 bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <div className="bg-[#FAFAF8] rounded-2xl p-10 border border-gray-100 relative">
              <div className="absolute -top-4 left-10">
                <div className="w-10 h-10 bg-[#F58B23] rounded-full flex items-center justify-center">
                  <Quote className="w-5 h-5 text-white" />
                </div>
              </div>
              <h3 className="text-2xl font-serif font-bold text-[#1A1A1A] mb-4">
                Our Promise
              </h3>
              <p className="text-lg text-[#6B7280] leading-relaxed italic">
                {whyTekClap.promise}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#1A1A1A]">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6">
              Experience the Difference
            </h2>
            <p className="text-gray-400 mb-8 text-lg">
              See how our approach translates into real results for your business.
            </p>
            <Link to="/contact">
              <Button
                size="lg"
                className="bg-[#F58B23] hover:bg-[#D97706] text-white font-medium px-10"
              >
                Start the Conversation
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyTekClapPage;
